// import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
// import { ntxAPI } from '../../API/axiosNeatex';
// import type { APIResponse } from '@store/Shared/shared';

// interface PhaseAssignment {
//   id: string;
//   organizationId: string;
//   phaseId: string;
//   sortOrder: number;
//   isActive: boolean;
// }

// export const addProjectPhaseAssignment = createAsyncThunk('Project/addProjectPhaseAssignment', async (item: any, { rejectWithValue }) => {
//   try {
//     const { data } = await ntxAPI.post<APIResponse<string>>('Project/AddProjectPhaseAssignment', item);
//     return data;
//   } catch (error: any) {
//     return rejectWithValue(error.message);
//   }
// });

// const initialState: {
//   phaseAssignments: PhaseAssignment[];
//   previousPhaseAssignments: PhaseAssignment[];
//   loading: boolean;
//   error: any | null;
// } = {
//   phaseAssignments: [],
//   previousPhaseAssignments: [],
//   loading: false,
//   error: null,
// };

// const projectPhaseSlice = createSlice({
//   name: 'ProjectPhase',
//   initialState,
//   reducers: {
//     updatePhaseAssignmentInList: (state, action: PayloadAction<{ assignmentId: string; updates: Partial<PhaseAssignment> }>) => {
//       const { assignmentId, updates } = action.payload;
//       const idx = state.phaseAssignments.findIndex(pa => String(pa.id) === String(assignmentId));
//       if (idx !== -1) {
//         state.phaseAssignments[idx] = { ...state.phaseAssignments[idx], ...updates };
//       }
//     },
//     rollbackPhaseAssignments: state => {
//       state.phaseAssignments = state.previousPhaseAssignments;
//     }
//   },
//   extraReducers(builder) {
//     // يمكن إضافة extra reducers للحالات الأخرى إذا كانت هناك APIs للحصول على البيانات
//   }
// });

// export const { updatePhaseAssignmentInList, rollbackPhaseAssignments } = projectPhaseSlice.actions;
// export default projectPhaseSlice.reducer;

import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../API/axiosNeatex';
import type { APIResponse } from '@store/Shared/shared';
import type { TaskModels } from '@store/Tasks/Task/taskSlice';

export interface PhaseAssignment {
  projectPhaseAssignmentId: string;
  phaseId: string;
  phaseCode: string;
  phaseName: string;
  phaseName2: string;
  description: number;
  sortOrder: number;
  isActive: boolean;
  tasksList: TaskModels[];
}

interface ProjectPhase {
  id: string;
  code: string;
  name: string;
  name2: string;
  description: string;
  isActive: boolean;
}

export const addProjectPhaseAssignment = createAsyncThunk(
  'Project/addProjectPhaseAssignment',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post<APIResponse<string>>('Project/AddProjectPhaseAssignment', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getProjectPhaseList = createAsyncThunk('Project/getProjectPhaseList', async (_, { rejectWithValue }) => {
  try {
    const { data } = await ntxAPI.get<APIResponse<ProjectPhase[]>>('Project/GetProjectPhaseList');
    return data;
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const getProjectPhaseByProjectId = createAsyncThunk(
  'Project/getProjectPhaseByProjectId',
  async (organizationId: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get<APIResponse<PhaseAssignment[]>>(
        `Project/GetProjectPhaseAssignmenByProjectId?organizationId=${organizationId}`
      );
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState: {
  phaseAssignments: PhaseAssignment[];
  previousPhaseAssignments: PhaseAssignment[];
  phaseList: ProjectPhase[];
  projectPhases: PhaseAssignment[];
  loading: boolean;
  error: any | null;
} = {
  phaseAssignments: [],
  previousPhaseAssignments: [],
  phaseList: [],
  projectPhases: [],
  loading: false,
  error: null
};

const projectPhaseSlice = createSlice({
  name: 'ProjectPhase',
  initialState,
  reducers: {
    updatePhaseAssignmentInList: (
      state,
      action: PayloadAction<{ assignmentId: string; updates: Partial<PhaseAssignment> }>
    ) => {
      const { assignmentId, updates } = action.payload;
      const idx = state.phaseAssignments.findIndex(pa => String(pa.projectPhaseAssignmentId) === String(assignmentId));
      if (idx !== -1) {
        state.phaseAssignments[idx] = { ...state.phaseAssignments[idx], ...updates };
      }
    },
    rollbackPhaseAssignments: state => {
      state.phaseAssignments = state.previousPhaseAssignments;
    }
  },
  extraReducers(builder) {
    builder
      // حالات fetchProjectPhaseList
      .addCase(getProjectPhaseList.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProjectPhaseList.fulfilled, (state, action) => {
        state.loading = false;
        state.phaseList = action.payload.data;
      })
      .addCase(getProjectPhaseList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // حالات fetchProjectPhaseByProjectId
      .addCase(getProjectPhaseByProjectId.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProjectPhaseByProjectId.fulfilled, (state, action) => {
        state.loading = false;
        state.projectPhases = action.payload.data;
      })
      .addCase(getProjectPhaseByProjectId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // حالات addProjectPhaseAssignment
      .addCase(addProjectPhaseAssignment.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addProjectPhaseAssignment.fulfilled, state => {
        state.loading = false;
      })
      .addCase(addProjectPhaseAssignment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { updatePhaseAssignmentInList, rollbackPhaseAssignments } = projectPhaseSlice.actions;
export default projectPhaseSlice.reducer;
